module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section04_04_american-village-93b4e1e3f50f7ec61160f7a29ab26aa7.jpg";